import { CartAndOrder } from "../../app/miscellaneous/orderAtom";
import { cartFlowSequence } from "./cartFlowSequence";

type OrderError = NonNullable<CartAndOrder["errors"]>[number];
type ErrorPage = typeof cartFlowSequence[number]["errorPage"] | undefined;

/**
 * The `errorGroup` could be changed to `errorCode` if `errorCodes` are unique.
 * Doing so would add a compile-time guarantee all error navigation is handled.
 */
export function groupErrorToPage(group: OrderError["errorGroup"]): ErrorPage {
  switch (group) {
    case "CustomerAgreements":
      return "Cart";
    case "CustomerInformation":
    case "ExportQuestions":
      return "ShippingAddressExport";
    case "BillingAddress":
    case "Cart":
    case "Confirmation":
    case "Payment":
    case "PaymentSaved":
    case "SampleQuestions":
    case "ShippingAddress":
    case "ShippingOption":
    case "SampleUserRegistration":
    case undefined:
      return group;
  }
}
